module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n<h1>\r\n    '+
((__t=(attributes.lang.UPDATE_PWD))==null?'':_.escape(__t))+
'\r\n    <small>'+
((__t=(attributes.first_name))==null?'':_.escape(__t))+
' '+
((__t=(attributes.last_name))==null?'':_.escape(__t))+
'</small>\r\n</h1>\r\n</section>\r\n\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-8">\r\n            <div class="box">\r\n                <div class="box-body">\r\n\r\n                    <form id="userProfile">\r\n                \r\n                        <div id="pwdHolder"></div>\r\n                        <div class="form-group">\r\n                            <label for="c_pwd">'+
((__t=(attributes.lang.CONFIRM_PWD))==null?'':_.escape(__t))+
'</label>\r\n                            <input type="password" id="c_pwd" class="form-control" placeholder="'+
((__t=(attributes.lang.PASSWD))==null?'':_.escape(__t))+
'" required disabled/>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <button type="button" class="btn btn-info" id="back"><span class="glyphicon glyphicon-arrow-left"></span>'+
((__t=(attributes.lang.BACK))==null?'':_.escape(__t))+
'</button>\r\n                            <button type="submit" class="btn btn-success" id="save" disabled>'+
((__t=(attributes.lang.SAVE))==null?'':_.escape(__t))+
'</button>\r\n                        </div>\r\n                    </form>                    \r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section> ';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/password/passwordView.ejs
// module id = 440
// module chunks = 0